<script>
export default {
	name: 'IconSvgXls',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.372 4.104C12.9073 4.10356 12.4617 3.92237 12.1331 3.60023C11.8045 3.27809 11.6197 2.8413 11.6193 2.38572V0H3.78736C3.18072 0 2.59892 0.23626 2.16996 0.656792C1.74099 1.07733 1.5 1.64768 1.5 2.2424V15.7602C1.5 16.3549 1.74099 16.9253 2.16996 17.3458C2.59892 17.7663 3.18072 18.0026 3.78736 18.0026H13.1883C13.795 18.0026 14.3768 17.7663 14.8058 17.3458C15.2347 16.9253 15.4757 16.3549 15.4757 15.7602V4.104H13.372Z"
				:fill="color" />
			<path
				d="M15.4757 4.104H13.372C12.9073 4.10355 12.4617 3.92237 12.1331 3.60023C11.8045 3.27809 11.6197 2.8413 11.6193 2.38572V0L15.4757 4.104Z"
				fill="#58B857" />
			<path
				d="M17.1349 14.2169H6.50646C5.75254 14.2169 5.14136 14.8161 5.14136 15.5552V18.6617C5.14136 19.4008 5.75254 20 6.50646 20H17.1349C17.8888 20 18.5 19.4008 18.5 18.6617V15.5552C18.5 14.8161 17.8888 14.2169 17.1349 14.2169Z"
				fill="#58B857" />
			<path d="M9.00663 17.7554V18.3612H8.36658V17.7554H9.00663Z" fill="#F3F3F6" />
			<path
				d="M10.8793 18.3613L10.3412 17.5813L9.87797 18.3613H9.16991L9.98675 17.0714L9.14441 15.8556H9.87797L10.4024 16.6105L10.8546 15.8556H11.5593L10.7535 17.1172L11.6137 18.3613H10.8793Z"
				fill="#F3F3F6" />
			<path
				d="M15.1687 18.0246C15.0953 18.1396 14.9901 18.2318 14.8652 18.2904C14.7132 18.3601 14.5467 18.3941 14.379 18.3895C14.126 18.3999 13.8766 18.3275 13.6701 18.1837C13.5788 18.1165 13.5041 18.03 13.4515 17.9306C13.399 17.8312 13.37 17.7215 13.3667 17.6096H14.0246C14.0293 17.694 14.0659 17.7736 14.1274 17.8329C14.1886 17.8888 14.2699 17.9188 14.3535 17.9162C14.3876 17.9182 14.4217 17.9135 14.454 17.9025C14.4862 17.8915 14.5159 17.8744 14.5414 17.8521C14.564 17.8305 14.5819 17.8045 14.5937 17.7759C14.6056 17.7472 14.6112 17.7163 14.6102 17.6854C14.611 17.656 14.6058 17.6268 14.5949 17.5994C14.5839 17.5721 14.5675 17.5472 14.5465 17.5262C14.5015 17.4816 14.4481 17.4459 14.3892 17.4213C14.3274 17.3946 14.2407 17.3621 14.1291 17.3237C13.9936 17.28 13.8613 17.2274 13.733 17.1663C13.6276 17.113 13.5371 17.0352 13.4695 16.9396C13.3911 16.8239 13.3524 16.6867 13.359 16.548C13.3559 16.4105 13.3963 16.2754 13.4746 16.1613C13.555 16.0498 13.6662 15.9631 13.7951 15.9113C13.9436 15.8521 14.1031 15.8237 14.2634 15.828C14.5068 15.8148 14.7473 15.8853 14.9434 16.0271C15.0269 16.0937 15.0953 16.1767 15.1442 16.2706C15.1931 16.3646 15.2214 16.4676 15.2273 16.5729H14.5584C14.5509 16.4992 14.5186 16.43 14.4666 16.3763C14.44 16.3513 14.4085 16.3319 14.374 16.3193C14.3395 16.3067 14.3027 16.3011 14.266 16.303C14.2022 16.3001 14.1396 16.3203 14.09 16.3596C14.0671 16.3809 14.0493 16.4069 14.0378 16.4357C14.0264 16.4645 14.0216 16.4954 14.0237 16.5263C14.0224 16.5823 14.0438 16.6365 14.0832 16.6771C14.1255 16.7204 14.1764 16.7547 14.2328 16.7779C14.2932 16.8038 14.3799 16.8371 14.4929 16.8771C14.6308 16.9212 14.7652 16.9752 14.895 17.0388C15.0009 17.0948 15.0923 17.1741 15.1619 17.2704C15.2412 17.388 15.2805 17.5271 15.2741 17.6679C15.2729 17.794 15.2365 17.9174 15.1687 18.0246Z"
				fill="#F3F3F6" />
			<path d="M12.4812 17.8972H13.3091V18.3613H11.8641V15.8556H12.4829L12.4812 17.8972Z" fill="#F3F3F6" />
			<path
				d="M11.6057 12.5695H5.37349C4.83374 12.5695 4.39429 12.0428 4.39429 11.3945V6.96221C4.39429 6.31474 4.83374 5.78809 5.37349 5.78809H11.6082C12.1471 5.78809 12.5866 6.31474 12.5866 6.96221V11.3945C12.584 12.0428 12.1446 12.5695 11.6057 12.5695ZM5.37349 6.38806C5.10914 6.38806 4.89495 6.64556 4.89495 6.96221V11.3945C4.89495 11.7112 5.10914 11.9687 5.37349 11.9687H11.6082C11.8717 11.9687 12.0859 11.7112 12.0859 11.3945V6.96221C12.0859 6.64556 11.8717 6.38806 11.6082 6.38806H5.37349Z"
				fill="#58B857" />
			<path d="M12.3342 9.90039H4.64258V10.5012H12.3342V9.90039Z" fill="#58B857" />
			<path d="M12.3342 7.84045H4.64258V8.44126H12.3342V7.84045Z" fill="#58B857" />
			<path d="M10.3638 6.08813H9.75098V12.2687H10.3638V6.08813Z" fill="#58B857" />
			<path d="M7.22479 6.08813H6.61194V12.2687H7.22479V6.08813Z" fill="#58B857" />
		</svg>
	</div>
</template>

<style scoped>

</style>